import { useEffect, useRef, useState } from 'react'
import './BudgetPieChart.scss'

import PieChartPart from './PieChartPart'
import BudgetForm from './BudgetForm'
interface Props {
    budgets: Budget[]
    newBudget: () => void
    deleteBudget: (budget: Budget) => void
    onUpdate: (budget: Budget, params: BudgetParams) => void
}


const BudgetPieChart = (props: Props) => {
    const { budgets, onUpdate, newBudget, deleteBudget } = props
    const pieChartRef = useRef<HTMLDivElement>(null)

    const [selectedBudget, setSelectedBudget] = useState(undefined as Budget | undefined)
    
    const totalAmountUpTo = (i: number) => budgets.slice(0, i).reduce((s: number, bu: Budget) => s + Math.max(bu.amount_cents, 5000), 0)
    const totalAmount = totalAmountUpTo(budgets.length)

    useEffect(() => {
        if(selectedBudget && budgets.map((b) => b.id).indexOf(selectedBudget.id) === -1) {
            setSelectedBudget(undefined)
        }
    },[budgets, selectedBudget])


    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [])

    const handleClickOutside = (e: any) => {
        if(!(pieChartRef?.current && pieChartRef?.current.contains(e.target))) {
            setSelectedBudget(undefined)
            e.preventDefault()
        }
    }

    
    const angleStart = (i: number) => totalAmountUpTo(i) * 360 / totalAmount

    return <div className='budgets-pie' ref={pieChartRef}>

        { budgets.map((budget, i) => {
            return <PieChartPart
                
                angleStart={angleStart(i)}
                angleEnd={angleStart(i+1)}
                icon={budget.icon}
                color={budget.color}
                onClick={() => setSelectedBudget(budget)}
            />
        })}

        
        { selectedBudget && <div className='center'>
            <BudgetForm budget={selectedBudget}
                onUpdate={(params) => onUpdate(selectedBudget, params)}
                onDelete={() => deleteBudget(selectedBudget)} />
        </div>}
        { !selectedBudget && <div className='center'>
            <div className="amount">{totalAmount / 100}€</div>
            <div className="button" onClick={newBudget}>
                <span className="icon fa fa-plus"/>
                <span className="label">Nouveau budget</span>
            </div>
        </div>}
    </div>

}

export default BudgetPieChart